import React from "react";
import StackedBarChart from "../ProgramDashboard/component/StackedBarChart/StackedBarChart.view";
import GroupedBarChart from "../ProgramDashboard/component/GroupedBarChart/GroupedBarChart.view";
import styles from "./Style.module.css";
import TrendChart from "../ProgramDashboard/component/TrendChart/TrendChart";
import useDoctorDashboard from "./DoctorDashboard.hook";
import DoctorTopField from "./component/DoctorTopField/DoctorTopField.view";
import DocTableComp from "./component/DocTable/DocTable.view";
import DialogWrapper from "../ProgramDashboard/component/DialogWrapper/DialogWrapper.view";

const customColors = {
  SKIPPED: "#F55D5D",
  COMPLETED: "#16C59B",
  SCHEDULED: "#F29E2F",
};

const defaultColors = {
  enrollment: "#f4a621",
  dropout: "#1f78c1",
};
const doctorColor = {
  enrollment: "#17BCD5",
  dropout: "#6D54E6",
};

const medicineColor = {
  refill_count: "#f4a621",
  consumption_count: "#1f78c1",
};

function DoctorDashboard() {
  const {
    form,
    changeTextData,
    rewardData,
    cityData,
    dropData,
    medicineRefill,
    medReminder,
    DocTable,
    groupedData,
    handleReset,
    sortDocTable,
    sortTable,
    groupedByDocData,
    isAllDocSelected,
    setExpandedView,
    expandedView,
    handleExpand,
    handleMedicineTrendExport,
    handleDoctorEnrollExport,
  } = useDoctorDashboard({});
  return (
    <div className={styles.dashboardContainer}>
      <DoctorTopField
        form={form}
        changeTextData={changeTextData}
        handleReset={handleReset}
      />
      <div className={styles.statsContainer}>
        <div className={styles.statCard}>
          <strong style={{ color: "#0080C1" }}>Total Patient Count</strong>{" "}
          <br /> {rewardData?.totalPatient ?? "-"}
        </div>
        <div className={styles.statCard}>
          <strong style={{ color: "#0080C1" }}>New Enrollment</strong> <br />{" "}
          {rewardData?.totalEnrollment ?? "-"}
        </div>
        <div className={styles.statCard}>
          <strong style={{ color: "#0080C1" }}>Active Patients</strong> <br />{" "}
          {rewardData?.totalActiveUsers ?? "-"}
        </div>{" "}
        <div className={styles.statCard}>
          <strong style={{ color: "#0080C1" }}>Dropouts</strong> <br />{" "}
          {rewardData?.totalDropout ?? "-"}
        </div>{" "}
        <div className={styles.statCard}>
          <strong style={{ color: "#0080C1" }}>
            Medicine consumption count
          </strong>{" "}
          <br /> {rewardData?.totalMedicineConsumption ?? "-"}
        </div>
      </div>
      {/* <div className={styles.formFlex}> */}
      <div className={"formFlex"}>
        <GroupedBarChart
          className={styles.enrollContainer}
          title="Enrollment vs Dropout"
          data={dropData}
          dataKey="label"
          colors={defaultColors}
          sx={{ backgroundColor: "#f5f5f5" }}
          isImgDownload
          isExport
          downloadTitle="Enrollment vs Dropout Download"
          handleExport={handleDoctorEnrollExport}
          isExpand
          onExpand={() =>
            handleExpand(
              "Enrollment vs Dropout",
              <GroupedBarChart
                title="Enrollment vs Dropout"
                data={dropData}
                dataKey="label"
                sx={{ backgroundColor: "#f5f5f5" }}
                colors={defaultColors}
                isExpand={false}
                isImgDownload={false}
              />
            )
          }
        />
      </div>
      <div className={"formFlex"}>
        <GroupedBarChart
          className={styles.enrollContainer}
          title="Medicine Consumption and Refills"
          data={medicineRefill}
          dataKey="label"
          colors={medicineColor}
          sx={{ backgroundColor: "#f5f5f5" }}
          isImgDownload
          isExpand
          isExport
          downloadTitle="Doctor Trend Download"
          handleExport={handleMedicineTrendExport}
          onExpand={() =>
            handleExpand(
              "Medicine Consumption and Refills",
              <GroupedBarChart
                title="Medicine Consumption and Refills"
                data={medicineRefill}
                dataKey="label"
                sx={{ backgroundColor: "#f5f5f5" }}
                colors={medicineColor}
                isExpand={false}
                isImgDownload={false}
              />
            )
          }
        />
      </div>
      {/* </div> */}

      {/* <div className={styles.formFlex}> */}
      <div className={"formFlex"}>
        <TrendChart
          trendData={groupedByDocData}
          title="Patient Enrollment Trend"
          isExport
          downloadTitle="Patient Enrollment Download"
          handleExport={handleDoctorEnrollExport}
          dataSet={[
            {
              label: "Active",
              data: groupedByDocData?.active || [],
              borderColor: "#E26D14",
              borderWidth: 1,
              pointBackgroundColor: "#E26D14",
              pointRadius: 2,
              fill: false,
            },
            {
              label: "Inactive",
              data: groupedByDocData?.inactive || [],
              borderColor: "#004DC1",
              borderWidth: 1,
              pointBackgroundColor: "#004DC1",
              pointRadius: 2,
              fill: false,
            },
          ]}
          isImgDownload
          isExpand
          onExpand={() =>
            handleExpand(
              "Doctor Trend",
              <GroupedBarChart
                title="Patient Enrollment Trend"
                dataSet={[
                  {
                    label: "Active",
                    data: groupedByDocData?.active || [],
                    borderColor: "#E26D14",
                    borderWidth: 1,
                    pointBackgroundColor: "#E26D14",
                    pointRadius: 2,
                    fill: false,
                  },
                  {
                    label: "Inactive",
                    data: groupedByDocData?.inactive || [],
                    borderColor: "#004DC1",
                    borderWidth: 1,
                    pointBackgroundColor: "#004DC1",
                    pointRadius: 2,
                    fill: false,
                  },
                ]}
                trendData={groupedByDocData}
                isExpand={false}
                isImgDownload={false}
              />
            )
          }
        />
      </div>
      <div className={"formFlex"}>
        <StackedBarChart
          title="Appointments"
          data={medReminder}
          dataKey="label"
          isImgDownload
          colors={customColors}
          isExpand
          isExport
          downloadTitle="Appointments Download"
          handleExport={handleDoctorEnrollExport}
          sx={{ backgroundColor: "#f5f5f5" }}
          onExpand={() =>
            handleExpand(
              "Appointments",
              <StackedBarChart
                title="Appointments"
                data={medReminder}
                dataKey="label"
                colors={customColors}
                sx={{ backgroundColor: "#f5f5f5" }}
                isExpand={false}
              />
            )
          }
        />
      </div>
      {/* </div> */}
      {isAllDocSelected && (
        <DocTableComp
          data={DocTable[sortTable] || []}
          sortDocTable={sortDocTable}
          sortTable={sortTable}
        />
      )}
      <DialogWrapper
        open={expandedView.open}
        onClose={() =>
          setExpandedView({ open: false, title: "", content: null })
        }
        title={expandedView.title}
      >
        {expandedView.content}
      </DialogWrapper>
    </div>
  );
}

export default DoctorDashboard;
